module.exports = __webpack_public_path__ + "bf58bca0d9cd6d939c4cf3c269d3efcd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-space.png
// module id = 2980
// module chunks = 0